/* ============
 * Actions for the event module
 * ============
 *
 * The actions that are available on the
 * user module.
 */
import axios from 'axios'

export default {
  eventLog ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'events/logs', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => { reject(err) })
      })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/event/actions.js